import { useState } from 'react'
import menuOpcoes from '../../interfaces/propsMenuOpcoes'
import SubMenuOpcoes from '../SubMenuOpcoes'
import { RiCustomerService2Fill } from "react-icons/ri";
import '../../styles/menuopcoes.css'
import Permissoes from '../../middleware/Permissoes';

function MenuAtendimento(props: menuOpcoes) {

    const [subMenu, setSubMenu] = useState(false)

    function exibirSubmenu() {
        setSubMenu(subMenu => !subMenu)
    }

    return (
        <Permissoes permissoes={['master', 'administrativo' ,'atendimento', 'atendimento_acesso']}>
            <div>
                <div id='menuOpcoes' onClick={exibirSubmenu}>
                    <RiCustomerService2Fill id='iconeMenu' color='#F1F1F3' />
                    <p id='tituloMenu'>{props.titulo}</p>
                    <h3>Novo</h3>
                </div>
                <Permissoes permissoes={['master', 'administrativo', 'atendimento', 'atendimento_lead']}>
                    <div id='submenuOpcoes'>
                        {subMenu && <SubMenuOpcoes redirect='/leads' texto='Leads' />}
                    </div>
                </Permissoes>
                <Permissoes permissoes={['master', 'administrativo', 'atendimento', 'atendimento_contato']}>
                    <div id='submenuOpcoes'>
                        {subMenu && <SubMenuOpcoes redirect='/contatos' texto='Contatos' />}
                    </div>
                </Permissoes>
                <Permissoes permissoes={['master', 'administrativo', 'atendimento_comunicado']}>
                    <div id='submenuOpcoes'>
                        {subMenu && <SubMenuOpcoes redirect='/comunicados' texto='Comunicados' />}
                    </div>
                </Permissoes>
            </div>
        </Permissoes>
    )
}

export default MenuAtendimento